import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons'
import { Flex, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreInsurance } from '@flecto/types'
import {
  DataTable,
  type DataTableColumn,
  type DataTableProps,
  Icon,
  TextCurrency,
  TextDate,
} from '@flecto/ui'

import { CellActions } from './CellActions'
import { CellName } from './CellName'

export type TableBookingInsurancesProps = Omit<
  DataTableProps<CoreInsurance>,
  'columns'
> & {
  insurances?: CoreInsurance[]
}

export function TableBookingInsurances({
  insurances,
  ...props
}: TableBookingInsurancesProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_insurances' })

  const columns: DataTableColumn<CoreInsurance>[] = [
    {
      accessor: 'id',
      title: t('label_product'),
      width: 250,
      render: (row) => <CellName insurance={row} />,
    },
    {
      accessor: 'quantity',
      title: t('label_quantity'),
      textAlign: 'center',
      render: (row) => <Text>{row.quantity ?? 1}</Text>,
    },
    {
      accessor: 'date',
      title: t('label_date_issued'),
      width: 280,
      render: (row) => (
        <Flex wrap='nowrap' align='center' gap='xs'>
          <TextDate size='sm' date={row.start_at} variant='datetime-brief' />
          <Icon icon={faArrowRightLong} />
          <TextDate size='sm' date={row.end_at} variant='datetime-brief' />
        </Flex>
      ),
    },
    {
      accessor: 'cost',
      title: t('label_insurance_cost'),
      render: (row) => <TextCurrency size='sm' cents={row.price_cents} />,
    },
    {
      accessor: 'actions',
      title: '',
      textAlign: 'center',
      render: (row) => <CellActions insurance={row} />,
    },
  ]

  return (
    <DataTable
      {...props}
      records={insurances}
      columns={columns}
      pinLastColumn
    />
  )
}
